import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { AButton } from '../../atoms';
import { MProductDetailListItem } from '../../molecules';
import { PRODUCT_CONFIG } from '../../../config/product.config';

class OProductDetailList extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			showAll: false,
		};

		this.bindHandles();
	}

	bindHandles() {
		this.handleLoadMore = this.handleLoadMore.bind(this);
	}

	handleLoadMore() {
		this.setState(prev => ({ showAll: !prev.showAll }));
	}

	render() {
		let showMoreButton;
		const stateItems = this.props.items.filter(item => item.value !== null);
		const items = this.state.showAll ? stateItems : stateItems.slice(0, PRODUCT_CONFIG.loadLimitProductInfo);

		if (stateItems && stateItems.length > PRODUCT_CONFIG.loadLimitProductInfo) {
			const buttonText = this.state.showAll ? 'PRODUCT_INFO_BUTTON.SHOW_LESS_PRODUCT_INFO' :
				'PRODUCT_INFO_BUTTON.SHOW_ALL_PRODUCT_INFO';
			showMoreButton = (
				<AButton
					value={buttonText}
					type="ghost"
					className="show-more-button"
					onClick={this.handleLoadMore}
				/>
			);
		}

		const priceFormat = {
			style: 'currency',
			currency: 'EUR',
			currencyDisplay: 'symbol',
			minimumFractionDigits: 0,
			maximumFractionDigits: 2,
		};

		return (
			<ul className={this.props.className}>
				{this.props.price && this.props.price > 0 && <MProductDetailListItem
					key="price"
					label="PRODUCT_INFO_LABEL.PRICE"
					value={this.props.intl.formatNumber(this.props.price, priceFormat)}
				/>}
				{
					items.map(item => (
						<MProductDetailListItem
							key={item.key}
							label={item.label}
							value={item.value}
							tooltip={PRODUCT_CONFIG.tooltips[item.key]}
						/>
					))
				}
				<li key="showMoreButton">
					{showMoreButton}
				</li>
			</ul>
		);
	}
}

OProductDetailList.propTypes = {
	items: PropTypes.array.isRequired,
	price: PropTypes.number,
	className: PropTypes.string,
};

OProductDetailList.defaultProps = {
	price: undefined,
	className: '',
};

export default injectIntl(OProductDetailList);



// WEBPACK FOOTER //
// ./src/components/organisme/product/_organisme.product-detail-list.js